import clsx from 'clsx'

import { Badge } from '@/shared/ui/Badge'

type StorePartnerBadgeProps = {
  label: string
  /** Sobre o thumbnail — fundo legível e quebra de linha para nomes longos. */
  overlay?: boolean
}

export const StorePartnerBadge = ({
  label,
  overlay = false
}: StorePartnerBadgeProps) => (
  <Badge
    variant="available"
    tone="light"
    size="sm"
    showIcon={false}
    className={clsx(
      overlay
        ? 'h-auto max-w-[75%] shrink-0 whitespace-normal break-words py-0.5 text-right leading-snug shadow-sm'
        : 'mb-1 max-w-full truncate'
    )}
  >
    {label}
  </Badge>
)
